import { render, staticRenderFns } from "./IntegralTask.vue?vue&type=template&id=1fb631de&scoped=true"
import script from "./IntegralTask.vue?vue&type=script&lang=js"
export * from "./IntegralTask.vue?vue&type=script&lang=js"
import style0 from "./IntegralTask.vue?vue&type=style&index=0&id=1fb631de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fb631de",
  null
  
)

export default component.exports